<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Engineering Science"
                   :links="[{title:'Home', url:'/'},{title:'Academic Achievers'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="7"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Academic Achievers</div>
          <tab-view class="">
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2020-21</span>
              </template>
              <div class="grid grid-cols-3 gap-5">
                <achiever-component
                    v-for="(users,index) in getResult('2020-21')"
                    :key="index"
                    :achiever="users">
                </achiever-component>
              </div>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2019-20</span>
              </template>
              <div class="grid grid-cols-3 gap-5">
                <achiever-component
                    v-for="(users,index) in getResult('2019-20')"
                    :key="index"
                    :achiever="users">
                </achiever-component>
              </div>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2018-19</span>
              </template>
              <div class="grid grid-cols-3 gap-5">
                <achiever-component
                    v-for="(users,index) in getResult('2018-19')"
                    :key="index"
                    :achiever="users">
                </achiever-component>
              </div>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2017-18</span>
              </template>
              <div class="grid grid-cols-3 gap-5">
                <achiever-component
                    v-for="(users,index) in getResult('2017-18')"
                    :key="index"
                    :achiever="users">
                </achiever-component>
              </div>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2016-17</span>
              </template>
              <div class="grid grid-cols-3 gap-5">
                <achiever-component
                    v-for="(users,index) in getResult('2016-17')"
                    :key="index"
                    :achiever="users">
                </achiever-component>
              </div>
            </tab-panel>
          </tab-view>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/science/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import AchieverComponent from "@/components/AchieverComponent";

export default {
  name: "landing-page",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    TabView,
    TabPanel,
    AchieverComponent
  },
  data() {
    return {
      results: [
        {
          year: '2020-21',
          students: [
            {
              name: 'Miss. Khan Tabassum Aqeel',
              image: '/static/images/science/academicAchievers/2020-21/khan_ta.jpg',
              score: 'CGPA - 9.55'
            },
            {
              name: 'Miss. Kudal Rupali Dattu',
              image: '/static/images/science/academicAchievers/2020-21/kudal_rd.jpg',
              score: ' CGPA - 9.55'
            },
            {
              name: 'Mr. Kadlag Narendra Vilas',
              image: '/static/images/science/academicAchievers/2020-21/kadlag_nv.jpg',
              score: 'CGPA - 9.32'
            },
            {
              name: 'Mr. Deshmukh Ujjwal Shivajirao ',
              image: '/static/images/science/academicAchievers/2020-21/deshmukh_us.jpg',
              score: 'CGPA - 9.20'
            },
            {
              name: 'Mr. Ansari Umair Ahmed Ehsanullah',
              image: '/static/images/science/academicAchievers/2020-21/unsari_ua.jpg',
              score: 'CGPA - 9.09'
            }
          ]
        },
        {
          year: '2019-20',
          students: [
            {
              name: 'Miss. Ahire Priyanka Ashok',
              image: '/static/images/science/academicAchievers/2019-20/ahire_pa.jpg',
              score: 'CGPA - 8.95'
            },
            {
              name: ' Miss. Satalkar Akshada Sopan',
              image: '/static/images/science/academicAchievers/2019-20/satalkar_as.jpg',
              score: 'CGPA - 8.68'
            },
            {
              name: '  Miss. Bornare Shraddha Pradip',
              image: '/static/images/science/academicAchievers/2019-20/bornare_sp.jpg',
              score: 'CGPA - 8.31'
            },
            {
              name: 'Miss. Deshmukh Kajal Arun',
              image: '/static/images/science/academicAchievers/2019-20/deshmukh_ka.jpg',
              score: 'CGPA - 8.31'
            },
            {
              name: 'Miss. Shukla Kavitadevi Anilkumar',
              image: '/static/images/science/academicAchievers/2019-20/shukla_ka.jpg',
              score: 'CGPA - 8.31'
            }
          ]
        },
        {
          year: '2018-19',
          students: [
            {
              name: ' Miss. Wakchaure Pratiksha Babasaheb',
              image: '/static/images/science/academicAchievers/2018-19/waghchuare_pb.jpg',
              score: 'CGPA - 9.16'
            },
            {
              name: ' Mr. Vishal Ramdas Gaikwad',
              image: '/static/images/science/academicAchievers/2018-19/vishal_rg.jpg',
              score: 'CGPA - 8.64'
            },
            {
              name: 'Miss. Jamdhade Akshada Janardhan',
              image: '/static/images/science/academicAchievers/2018-19/jamdhade_ag.jpg',
              score: 'CGPA - 8.42'
            },
            {
              name: 'Miss. Jagzap Payal Changdev',
              image: '/static/images/science/academicAchievers/2018-19/jagjap_pc.jpg',
              score: 'CGPA - 8.40'
            },
            {
              name: 'Mr. Kherud Tejas Devkan',
              image: '/static/images/science/academicAchievers/2018-19/kherud_td.jpg',
              score: 'CGPA - 8.38'
            },

          ]
        },
        {
          year: '2017-18',
          students: [
            {
              name: ' Miss. Pokale Apeksha Sunil',
              image: '/static/images/science/academicAchievers/2017-18/pokale_pa.jpg',
              score: 'CGPA - 9.10'
            },
            {
              name: ' Mr. Jagtap Akshay Vilas',
              image: '/static/images/science/academicAchievers/2017-18/jagtap_av.jpg',
              score: 'CGPA - 8.98'
            },
            {
              name: 'Miss. Avhad Komal Vilas',
              image: '/static/images/science/academicAchievers/2017-18/avad_kv.jpg',
              score: 'CGPA - 8.80'
            },
            {
              name: 'Mr. Kandalkar Dagadu Sadas',
              image: '/static/images/science/academicAchievers/2017-18/khandalkar_da.jpg',
              score: 'CGPA - 8.72'
            },
            {
              name: 'Miss. Pawar Dhanshree Yogesh',
              image: '/static/images/science/academicAchievers/2017-18/pawar_dy.jpg',
              score: 'CGPA - 8.34'
            },

          ]
        },
        {
          year: '2016-17',
          students: [
            {
              name: ' Mr. Madhavai Pankaj Balasaheb',
              image: '/static/images/science/academicAchievers/2016-17/madwai_pankaj.jpg',
              score: 'CGPA - 9.50'
            },
            {
              name: ' Miss. Shelke Ashwini Ashok',
              image: '/static/images/science/academicAchievers/2016-17/shelake_ashwini.jpg',
              score: 'CGPA - 9.34'
            },
            {
              name: 'Miss. Bhabad Ankita Sanjay',
              image: '/static/images/science/academicAchievers/2016-17/bhabad_ankita.jpg',
              score: 'CGPA - 9.04'
            },
            {
              name: 'Mr. Satalkar Sanket Sanjay',
              image: '/static/images/science/academicAchievers/2016-17/satarkar_ss.jpg',
              score: 'CGPA - 9.00'
            },
            {
              name: 'Mr. Kolhe Swapnil Ramdas',
              image: '/static/images/science/academicAchievers/2016-17/kolhe_swapnil.jpg',
              score: 'CGPA - 8.8'
            },

          ]
        },]
    }
  },
  methods: {
    getResult(year) {

      const s = this.results.filter(item => {
        return item.year === year
      });

      const result = JSON.parse(JSON.stringify(s))
      // console.log(result[0].students)
      return result[0].students;
    }
  }

}
</script>
<style lang="scss" scoped/>
